import React from 'react';

interface QRCodeProps {
  value: string;
  size?: number;
  color?: string;
  backgroundColor?: string;
  logoUrl?: string;
  logoSize?: number;
  logoBackgroundColor?: string;
  logoMargin?: number;
  logoBorderRadius?: number;
  ecl?: 'L' | 'M' | 'Q' | 'H';
}

const QRCode: React.FC<QRCodeProps> = ({
  value,
  size = 256,
  color = '#000000',
  backgroundColor = '#FFFFFF',
  logoUrl,
  logoSize = 80,
  logoBackgroundColor = '#FFFFFF',
  logoMargin = 8,
  logoBorderRadius = 8,
  ecl = 'H'
}) => {
  const qrApiUrl = `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(value)}&color=${color.replace('#', '')}&bgcolor=${backgroundColor.replace('#', '')}&ecc=${ecl}`;

  return (
    <div 
      className="relative inline-block"
      style={{ width: size, height: size }}
    >
      <img
        src={qrApiUrl}
        alt="QR Code"
        style={{ width: size, height: size }}
        className="block"
      />
      {logoUrl && (
        <div 
          className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
          style={{ 
            width: logoSize + logoMargin * 2, 
            height: logoSize + logoMargin * 2,
            backgroundColor: logoBackgroundColor,
            borderRadius: logoBorderRadius,
            padding: logoMargin,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <img
            src={logoUrl}
            alt="Logo"
            style={{
              width: logoSize,
              height: logoSize,
              objectFit: 'cover',
              borderRadius: logoBorderRadius - logoMargin
            }}
          />
        </div>
      )}
    </div>
  );
};

export default QRCode;
